import { render, staticRenderFns } from "./PreviewPPT.vue?vue&type=template&id=43b4636b&scoped=true"
import script from "./PreviewPPT.vue?vue&type=script&lang=js"
export * from "./PreviewPPT.vue?vue&type=script&lang=js"
import style0 from "./PreviewPPT.vue?vue&type=style&index=0&id=43b4636b&prod&lang=scss&scoped=true"
import style1 from "./PreviewPPT.vue?vue&type=style&index=1&id=43b4636b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b4636b",
  null
  
)

export default component.exports